import { atom, useAtom, useAtomValue } from '@/core/features/store/atom-store';
import { filterGroupsAtom } from '@/features/filter/filter-data/filter-data-attributes-state';
import { buildQuickFilterCollection } from '@/features/filter/quick-filter/quick-filter-service';

/**
 * State Atoms
 */
const isQuickFilterOverlayOpenAtom = atom(false);
const selectedQuickFiltersAtom = atom<null | string[]>(null);

/**
 * Derived State Atoms
 */
const selectedQuickFilterGroupsAtom = atom((get) =>
    get(filterGroupsAtom).filter((group) => get(selectedQuickFiltersAtom)?.includes(group.name)),
);
const quickFilterCollectionAtom = atom((get) => buildQuickFilterCollection(get(filterGroupsAtom)));
const activeQuickFilterCollectionAtom = atom((get) =>
    get(quickFilterCollectionAtom).filter((quickFilter) => quickFilter.hasSelectedFilterOptions),
);

/**
 * Hooks
 */
const useQuickFilterOverlayOpen = () => useAtom(isQuickFilterOverlayOpenAtom);

const useSelectedQuickFilters = () => useAtom(selectedQuickFiltersAtom);

export const useSelectedQuickFilterGroups = () => useAtomValue(selectedQuickFilterGroupsAtom);

export const useQuickFilterCollection = () => useAtomValue(quickFilterCollectionAtom);

export const useActiveQuickFilterCollection = () => useAtomValue(activeQuickFilterCollectionAtom);

export const useQuickFilterOverlayToggle = () => {
    const [_selectedQuickFilters, setSelectedQuickFilters] = useSelectedQuickFilters();
    const [isQuickFilterOverlayOpen, setQuickFilterOverlayOpen] = useQuickFilterOverlayOpen();

    const openQuickFilterOverlay = (selectedQuickFilters: string[]) => {
        setSelectedQuickFilters(selectedQuickFilters);
        setQuickFilterOverlayOpen(true);
    };

    const closeQuickFilterOverlay = () => {
        setQuickFilterOverlayOpen(false);
        setSelectedQuickFilters(null);
        setTimeout(() => {
            setSelectedQuickFilters([]);
        }, 200);
    };

    return { closeQuickFilterOverlay, isQuickFilterOverlayOpen, openQuickFilterOverlay };
};
